import { Meta, Button } from 'src/presentation/components'

import S from './scripts.module.scss'

const LINKS = [
  { label: 'V8', url: 'https://drive.google.com/drive/folders/1cn5PrHPyhnkmaMps-Z9mI-ip7OtLzyQX?usp=drive_link' },
  { label: 'TOTAL CASH', url: 'https://drive.google.com/drive/folders/1VXR3TopSQWVak8NM0Zy-7UBcnoQn7_wM?usp=drive_link' },
  { label: 'SAFRA', url: 'https://drive.google.com/drive/folders/11ktyNCU9PjyxH3NfT2QvgUdsEy-bKfQX?usp=drive_link' },
  { label: 'QUERO+', url: 'https://drive.google.com/drive/folders/1FiXePK33zC4-6QO24dsNYkfrRM5gbkwe?usp=drive_link' },
  { label: 'QUALICARD', url: 'https://drive.google.com/drive/folders/1XbuB8PjaQIIsJiIJ6dWFvwNnVXt2swv_?usp=drive_link' },
  { label: 'QUALIBANKING', url: 'https://drive.google.com/drive/folders/1ixtBUsNVbLiEbIJaFTw81tQkagHIkQXQ?usp=drive_link' },
  { label: 'PRESENÇA BANK', url: 'https://drive.google.com/drive/folders/1zOk7LimhU04mUdWxN4xb7l1d_NA-2BUe?usp=drive_link' },
  { label: 'PAN', url: 'https://drive.google.com/drive/folders/12FlyPcEMTSm_5kDMEVVbxmmYebSuMbJC?usp=drive_link' },
  { label: 'MERCANTIL', url: 'https://drive.google.com/drive/folders/1_z5-M7RsZpkuY9nhsY00Y6tfuYJQ7Lg-?usp=drive_link' },
  { label: 'MASTER', url: 'https://drive.google.com/drive/folders/1qt9MHpSmAh4z23UBKu4pLaeYltjnmG8V?usp=drive_link' },
  { label: 'ITAU', url: 'https://drive.google.com/drive/folders/1s7R0fdQjWy7zGOV7UzdQRiMtJ87dnVJw?usp=drive_link' },
  { label: 'ICRED', url: 'https://drive.google.com/drive/folders/1jy1dWJJmOPeSHvC7U0JiO7juFsOtRS80?usp=drive_link' },
  { label: 'GO! CONSIG', url: 'https://drive.google.com/drive/folders/1pyKDCPuNjU5ST478GslXZim_0NWcL8DJ?usp=drive_link' },
  { label: 'FACTA', url: 'https://drive.google.com/drive/folders/1jQL5bTimC0xwSXTPaaIxc69hl2t2Y2ba?usp=drive_link' },
  { label: 'DIGIO', url: 'https://drive.google.com/drive/folders/1IQW9ZFfAYST1sn-TOqtoaHormLr6tXgb?usp=drive_link' },
  { label: 'DAYCOVAL', url: 'https://drive.google.com/drive/folders/1YkQ3mTisib8zRdOCxkMKsOb57F16Zhds?usp=drive_link' },
  { label: 'C6', url: 'https://drive.google.com/drive/folders/1Og8ospOw8JZFcA6FDBhdISm8zDDYXEPF?usp=drive_link' },
  { label: 'BRB', url: 'https://drive.google.com/drive/folders/1G-7LmyJ3S3KQ_alqE3K2ZxgPnKuT49WY?usp=drive_link' },
  { label: 'BMG', url: 'https://drive.google.com/drive/folders/1p1dW0Kdhhqn2EuANfpOQ3PpmTHcdKfjj?usp=drive_link' },
  { label: 'BANRISUL', url: 'https://drive.google.com/drive/folders/1TTNdYeCM31dqbON-hFsiGiqEyV18BX-3?usp=drive_link' },
  { label: 'AMIGOZ', url: 'https://drive.google.com/drive/folders/1g5G_bWGnJS270PFionhbtWOGXBux2Jas?usp=drive_link' },
]

const Scripts = () => (
  <div>
    <Meta
      title="Roteiros"
      description="Roteiros de atendimento e materiais de apoio"
      keywords="roteiros, atendimento"
    />
    <section className={S.container}>
      <h1 className={S.title}>Roteiros</h1>
      <div className={S.buttons}>
        {LINKS.map(({ label, url }) => (
          <a key={label} href={url} target="_blank" rel="noopener noreferrer">
            <Button typeStyle="btn2" label={label} width="200px" />
          </a>
        ))}
      </div>
    </section>
  </div>
)

export default Scripts
